import home_bg from "../assets/images/common/productbg.png";
import connect_banner from "../assets/images/banner/connect_b.png";
import track from "../assets/images/products/track.svg";
import notification from "../assets/images/products/notification.svg";
import connect_img from "../assets/images/products/connect_img.png";
import tick from "../assets/images/products/tick.svg";
import quote from "../assets/images/banner/quote.svg";
import "../modules/product_css.scss";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import qr_bg from "../assets/images/common/product_qr.png";
import connect_logo from "../assets/images/products/connect_logo.svg";
import play_w from "../assets/images/products/play_w.svg";
import qr from "../assets/images/products/connect_qr.svg";
import c_i from "../assets/images/products/c_i.svg";
import w1 from "../assets/images/products/connect/w1.svg";
import w2 from "../assets/images/products/connect/w2.svg";
import w3 from "../assets/images/products/connect/w3.svg";
import w4 from "../assets/images/products/connect/w4.svg";
import w5 from "../assets/images/products/connect/w5.svg";
import mandi_p from "../assets/images/common/mandi_p.png";
import click_p from "../assets/images/common/click_p.png";
import stars_s from "../assets/images/common/stars_s.svg";
import con_mob from "../assets/images/products/con_mob.png";
import { Link } from "react-router-dom";
import cash_p from "../assets/images/common/cash_p.png";
import AOS from "aos";
const Connect = () => {
  var banner_background = {
    backgroundImage: `url(${home_bg})`,
  };
  AOS.init();
  var qr_backg = {
    backgroundImage: `url(${qr_bg})`,
  };
  const features_array = [
    {
      icon: track,
      header: "Location Based Intelligence",
      para: "Based on your location coordinates all MANDIs / APMCs are sorted in distance ascending order with address details.",
      center: false,
    },
    {
      icon: c_i,
      header: "Up to 5 Crops & 7 Days Prices",
      para: "You can select up to 5 crops to know and compare real-time prices across MANDIs / APMCs and you can see historical price trends up to 7 days. ",
      center: true,
    },
    {
      icon: notification,
      header: "Real Time Alerts / Notifications",
      para: "You can set crop and price alerts to receive real-time notifications, ensuring you stay informed about price fluctuations for your selected crops.",
      center: false,
    },
  ];
  const choose_list = [
    {
      header: "Discover MANDI / APMC",
      para: "Able to discover all available neighbourhood MANDIs and AMPCs at your fingertips, for a comprehensive understanding of each market.",
    },
    {
      header: "Market Price Intelligence",
      para: "Discover crop market prices across MANDIs / APMCs and make informed decisions to sell the crop at best price, providing valuable insights into market dynamics.",
    },
    {
      header: "Farmer Smartboard",
      para: "Track all your crop sales and credit transactions details including crops varieties, quantities, rates, invoices and advances in a single view.",
    },
    {
      header: "Timely Credit Access",
      para: "Instant formal credit access through your MANDI partners empowering farmers with financial flexibility and support for their agricultural endeavours.",
    },
  ];
  const cust_slider = [
    {
      header: "Deepak Kumar",
      para: "ONO has now become a daily habit for me. I check the ONO app daily for the prices and share the price information with my friends too. Now I use only the ONO app for price updates and have got rid of all other apps. Best thing with Ono app is that the price gets updated daily and I can trust ONO app for accurate prices across all markets.",
      sub: "Trader",
    },
    {
      header: "Hemen Verma ",
      para: "ONO app benefited me a lot. I am constantly updated on the price for my produce. Not only I can now compare the prices of nearby mandis during the day but I can keep a look at the prices for more than two days. This gives me a clear idea of where I should be selling my produce for maximum profits... ",
      sub: "Farmer",
    },
    {
      header: "Abhay Pratap Singh ",
      para: "I earned Rs 12 more per kg on my agricultural produce by selling at the right mandi! Thanks to the ONO app for helping me get the right price of my yield. Earlier my father used to sell vegetables at a nearby mandi and would earn so much less. This time however we took our product to the right market...",
      sub: "Farmer",
    },
  ];
  const products = [
    {
      header: "ONO CLICK ",
      sub: "SIMPLE  |  SAFE  |  SECURE ",
      para: "APMC / MANDI SaaS platform for Commission Agents and Traders that offers Price and Market Intelligence, Payments, Collections and Digitization of APMC / MANDI Operations.",
      img: click_p,
      link: "/click",
    },
    {
      header: "ONO MANDI  ",
      sub: "SELL  |  BUY  |  GROW",
      para: "A mid-mile trading platform for traders. It enables supply and demand visibility, price intelligence, market discovery and seamless connectivity among APMCs / MANDIs. ",
      img: mandi_p,
      link: "/mandi",
    },
    {
      header: "ONO CASH ",
      sub: "QUICK  |  EASY  |  AFFORDABLE",
      para: "Neo-Lending platform for farmers, commission agents, and traders. It offers timely access to formal finance through invoice discounting, working capital loans and farmer advances.  ",
      img: cash_p,
      link: "/cash",
    },
  ];
  const works_data = [
    {
      header: "Create Discovery Account",
      para: "Download ONO CONNECT platform and create price and market discovery account in simple steps.",
      img: w1,
    },
    {
      header: "Preferred Crops and Mandis",
      para: "Configure your preferred crops and mandis for real-time price and mandi intelligence alerts / notifications.",
      img: w2,
    },
    {
      header: "Compare Crop \n Prices",
      para: "Compare crop prices across your Mandis and keep track of real-time prices to make smart decisions of harvesting timings.",
      img: w3,
    },
    {
      header: "Apply for Formal Advance",
      para: "Apply formal advances through your Mandi partners and gain access to timely capital for your farming needs.",
      img: w4,
    },
    {
      header: "CONNECT \n Smartboard",
      para: "Keep track of all your harvest cycles, quantities, sales price, transactions, transportation costs, profits, & interest saving.",
      img: w5,
    },
  ];
  const state2 = {
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 3,
        stagePadding: 200,
      },
    },
  };
  return (
    <div className="main_sec about_scroll">
      <section
        class="banner innerPageBanner click_banner"
        style={banner_background}
      >
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-6 col-xs-12 pl-0">
              <div class="d-block d-sm-block d-md-none">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <img src={connect_banner} alt="image" className="click_img" />
                </div>
              </div>
              <div class="banner_head">
                <h4 class="home_text pl-0">
                  <a
                    onClick={() => {
                      window.location.href = "/";
                    }}
                  >
                    HOME
                  </a>{" "}
                  : Products : Connect
                </h4>
                <h1 data-aos="fade-up" data-aos-duration="1000">
                  Your Trusted Price and Market Discovery Platform
                </h1>
                <p
                  className="body_para_main"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  Crop price and mandi discovery platform for farmers. Platform
                  makes it possible to locate neighbouring APMCs / Mandis and
                  offers real-time, accurate crop prices across Mandis.
                </p>
                <h5 data-aos="fade-up" data-aos-duration="1000">
                  CONNECT | DISCOVER | DECIDE
                </h5>
                <a
                  href="https://play.google.com/store/apps/details?id=com.ono.ono_flutter&hl=en_IN&gl=US"
                  target="_blank"
                >
                  <button className="secondry_btn">
                    Click here to Download
                  </button>
                </a>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-xs-12">
              <div class="d-none d-sm-none d-md-block">
                <img
                  src={connect_banner}
                  alt="image"
                  className="click_img d-flex mx-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="common_sec_padding">
        <div className="container features_container">
          <div className="d-flex align-items-center">
            <div className="border_line"></div>
            <h2 className="section_head1">Features</h2>
            <div className="border_line"></div>
          </div>
          <div className="row common_row">
            {features_array.map((item, i) => {
              return (
                <div className="col-lg-4">
                  <div
                    className={
                      item.center
                        ? "card features_card features_card_center"
                        : "card features_card"
                    }
                  >
                    <img src={item.icon} className="" allt="image" />
                    <h5>{item.header}</h5>
                    <p>{item.para}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="common_sec_padding pt-0">
        <div className="container">
          <div className="d-flex align-items-center head_line">
            <div className="border_line"></div>
            <h2 className="section_head1">Benefits</h2>
            <div className="border_line"></div>
          </div>
          <h2 className="section_head collor_black">
            Explore why choose ONO CONNECT?
          </h2>
          <div class="row product_tab_c align-items-center common_row">
            <div class="col-lg-6 col-md-7 col-xs-12 p-0">
              <div class="d-block d-sm-block d-md-none">
                <div class="col-lg-5 col-md-6 col-xs-12">
                  <img
                    src={connect_img}
                    alt="image"
                    data-aos="fade-left"
                    data-aos-duration="1000"
                    class="img-fluid img-responsive product_img"
                  />
                </div>
              </div>

              <ul className="">
                {choose_list.map((item, i) => {
                  return (
                    <li
                      class="d-flex align-items-start"
                      data-aos="fade-right"
                      data-aos-duration="1000"
                    >
                      <img src={tick} class="tick" alt="img" />
                      <div>
                        <h3>{item.header}</h3>
                        <p>{item.para}</p>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div class="col-lg-6 col-md-6 col-xs-12 ">
              <div class="d-none d-sm-none d-md-block">
                <img
                  src={connect_img}
                  alt="image"
                  class="img-responsive d-flex mx-auto"
                  data-aos="fade-left"
                  data-aos-duration="1000"
                />
                <a
                  href="https://play.google.com/store/apps/details?id=com.ono.ono_flutter&hl=en_IN&gl=US"
                  target="_blank"
                >
                  <button className="primary_btn d-flex mx-auto">
                    CLICK here to Download
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="how_it_works_main">
        <div className="how_it_works">
          <div className="container">
            <div className="common_sec_padding">
              <h2 className="section_head color_white">How it works?</h2>
              <div className="works_line"></div>
              <div className="d-flex common_row justify-content-between">
                {works_data.map((item, i) => {
                  return (
                    <div className="card ">
                      <h5 className="number_work">
                        <img src={item.img} />
                      </h5>
                      <h6>{item.header}</h6>
                      <p>{item.para}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className="customers mt-0">
          <div className="container">
            <div className="d-flex align-items-center">
              <div className="border_line white_border"></div>
              <h2 className="section_head1 color_white">Success stories</h2>
              <div className="border_line white_border"></div>
            </div>
          </div>
          <div className="stories_row common_row p-0">
            <OwlCarousel
              items={3}
              className="owl-theme banner_car cust_car cust_car_products"
              margin={20}
              loop
              dots={false}
              nav
              responsive={state2.responsive}
              autoplay={true}
              autoplayTimeout={2000}
              autoplayHoverPause={true}
              // autoHeightClass="owl-height"
            >
              {cust_slider.map((item, i) => {
                return (
                  <div className="item">
                    <div className="card">
                      <div className="">
                        <div>
                          <h2 className="section_head text-left color_white">
                            {item.header}
                          </h2>
                        </div>
                        <img src={stars_s} alt="stars" className="star_icon" />
                      </div>
                      <p className="sub_para stories_para text-left">
                        {item.para}
                      </p>
                      <img src={quote} alt="stars" />
                    </div>
                  </div>
                );
              })}
            </OwlCarousel>
          </div>
        </div>
      </div>
      <div className="qr_background common_sec_padding">
        <div className="container">
          <div
            className="common_sec_padding pb-0 qr_background_sub"
            style={qr_backg}
          >
            <div className="row align-items-center">
              <div className="col-lg-5">
                <div class="d-none d-sm-none d-md-block">
                  <img src={con_mob} alt="image" />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="d-flex align-items-center">
                  <div className="text-center">
                    <div>
                      <img
                        src={connect_logo}
                        className="ctalogo"
                        alt="ono-image"
                      />
                    </div>
                    <img src={qr} className="qr_icon" alt="qr" />
                  </div>
                  <div className="play_store_sec">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.ono.ono_flutter&hl=en_IN&gl=US"
                      target="_blank"
                    >
                      <img
                        src={play_w}
                        className="cta_playstore"
                        alt="playstore"
                      />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.ono.ono_flutter&hl=en_IN&gl=US"
                      target="_blank"
                    >
                      <p>
                        Download<br></br>
                        <span>ONO CONNECT</span> App Now
                      </p>
                    </a>
                  </div>
                </div>
              </div>
              <div class="d-block d-sm-block d-md-none">
                <img src={con_mob} className="con_mob" alt="image" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="common_sec_padding">
        <div className="container">
          <div className="d-flex align-items-center head_line">
            <div className="border_line"></div>
            <h2 className="section_head1">Other PRODUCTS</h2>
            <div className="border_line"></div>
          </div>
          <div className="row all_prod_row common_row">
            {products.map((item, i) => {
              return (
                <div className="col-lg-4">
                  <div className="card">
                    <h4>{item.header}</h4>
                    <h5>{item.sub}</h5>
                    <p>{item.para}</p>
                    <Link to={item.link}>
                      <button className="secondry_btn">Learn More</button>
                    </Link>
                    <img src={item.img} alt="image" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Connect;
